import { DgHubClientService } from "../Services/dg-hub-client.service";

export class Configs
{
  private static _service:DgHubClientService

  static init(service:DgHubClientService)
  {
      Configs._service = service;
  }

  static waveMarkerLocationOffset()
  {
    return{
      x:0,
      yUp:-15,
      yDown:15
    }
  }
}
